import { useEffect } from 'react';
import { onRealtimeEvent } from '../services/realtimeService';
import { isAuthenticated } from '../services/authService';
import { subscribeToPush } from '../services/notificationService';

const showNotification = ({ title, body, data = {} }) => {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  navigator.serviceWorker?.ready.then((registration) => {
    registration.showNotification(title, {
      body,
      icon: '/icon-192x192.png',
      badge: '/icon-192x192.png',
      data,
    });
  });
};

const NotificationListener = () => {
  useEffect(() => {
    if (!isAuthenticated()) return;
    if (!('Notification' in window) || Notification.permission !== 'granted') return;
    subscribeToPush().catch(() => {
      // Realtime updates continue even if push subscription fails.
    });
  }, []);

  useEffect(() => {
    const offOrderStatus = onRealtimeEvent('order.status', (payload) => {
      const status = payload?.order?.status || 'updated';
      const orderId = payload?.order?.id;
      showNotification({
        title: 'Order Update',
        body: orderId ? `Order #${orderId} is now ${status}.` : `Order ${status}.`,
        data: { path: orderId ? `/orders/${orderId}/track` : '/orders' },
      });
    });

    const offOrderAssigned = onRealtimeEvent('order.assigned', (payload) => {
      const orderId = payload?.orderId;
      const eta = payload?.etaMin;
      showNotification({
        title: 'Driver Assigned',
        body: eta
          ? `Order #${orderId} has a driver. ETA about ${eta} min.`
          : `A driver has been assigned to order #${orderId}.`,
        data: { path: orderId ? `/orders/${orderId}/track` : '/orders' },
      });
    });

    const offTrackingUpdate = onRealtimeEvent('tracking.update', (payload) => {
      const orderId = payload?.tracking?.order_id;
      const status = payload?.tracking?.status;
      showNotification({
        title: 'Tracking Update',
        body: orderId && status ? `Order #${orderId}: ${status}` : 'Your order has a new tracking update.',
        data: { path: orderId ? `/orders/${orderId}/track` : '/orders' },
      });
    });

    const offPaymentStatus = onRealtimeEvent('payment.status', (payload) => {
      const orderId = payload?.orderId;
      const status = payload?.status;
      showNotification({
        title: 'Payment Alert',
        body: orderId ? `Payment for order #${orderId} is ${status}.` : 'Payment status changed.',
        data: { path: orderId ? `/orders/${orderId}/track` : '/orders' },
      });
    });

    const offPromotion = onRealtimeEvent('promotion.broadcast', (payload) => {
      showNotification({
        title: payload?.title || 'New Promotion',
        body: payload?.body || 'Check out new offers on Skhaftin.',
        data: payload?.data || { path: '/restaurants' },
      });
    });

    return () => {
      offOrderStatus();
      offOrderAssigned();
      offTrackingUpdate();
      offPaymentStatus();
      offPromotion();
    };
  }, []);

  return null;
};

export default NotificationListener;
